import React, { Component } from 'react';
import { Container, Table, Row, Col, Input, TabContent, TabPane, Nav, NavItem, NavLink, Button } from 'reactstrap';
import {
    NavLink as NavLinkRouter,
} from 'react-router-dom';
import './Demographics.css';
import 'bootstrap/dist/css/bootstrap.css';
import NotesForm from '../../components/Notes/NotesForm.js';
import Addresses from '../../components/Addresses/Addresses.js';
import Contacts from '../../components/Contacts/Contacts.js';
import SalesOpportunitiesForm from '../../components/SalesOpportunitiesAdmin/demographicsForm/SalesOpportunitiesForm.js';
import DemographicsGraph from '../../components/GraphResults/DemographicsGraph.js';
import DemographicsEntry from './DemographicsEntry.js';
import Marketing2CampaignsDemographicsTable from '../../components/Marketing2/Marketing2CampaignsDemographicsTable';
import CollapseCard from '../../components/CollapseCard/CollapseCard.js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import { faStar as faStarOutline } from '@fortawesome/free-regular-svg-icons'
import classnames from 'classnames';
import { Prompt } from 'react-router-dom';
import CompanyContext from '../../auth/CompanyContext.js';
import CompanyCustodians from '../../components/Custodians/CompanyCustodians.js';

class Demographics extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);
        const queryParameters = new URLSearchParams(props.location?.search || '');
        const requestedSalesOpportunity = String(queryParameters.get('salesOpportunity') || '').split(':');
        this.requestedSalesOpportunityType = props.location?.state?.salesOpportunityType || requestedSalesOpportunity[0];
        this.requestedSalesOpportunityID = props.location?.state?.salesOpportunityID || requestedSalesOpportunity[1];
        this.requestedActiveTab = parseInt(queryParameters.get('activeTab'));
        this.available_dates = props.available_dates.filter(item => item.date_key !== '000000');
        this.newID = String(this.props.location.pathname).split('/')[2];
        this.secID = '';
        this.orgID = 0;
        String(this.newID).split('_').forEach(item => {
            if (item.indexOf('-') === -1 && Number.isInteger(parseInt(item))) {
                this.secID = item;
                this.orgID = item;
            } else if (item.indexOf('-') > -1) {
                this.secID = item;
            }
        })
        this.state = {
            ...props,
            currentDate: ("location" in this.props &&
                "state" in this.props.location && this.props.location.state != null &&
                "currentDate" in this.props.location.state &&
                this.props.location.state.currentDate != null)
                ? this.props.location.state.currentDate
                : this.props.available_dates[this.props.available_dates.length - 1].date_key,
            secID: this.secID,
            orgID: this.orgID,
            favorites: this.props.getFavorites(),
            searchState: (this.props.location.state != null && "searchState" in this.props.location.state) ? this.props.location.state.searchState : null,
            notes: [],
            notesLoading: true,
            otherCategories: {},
            prevLinkedID: null,
            addCategoryCommentsArray: [],
            editCategoryCommentsArray: [],
            selectValue: 0,
            linkedCompanies: {},
            editID: 0,
            dateRange: [],
            activeTab: this.requestedSalesOpportunityType === 'Sale'
                ? 4
                : this.requestedSalesOpportunityType === 'Opportunity'
                    ? 3
                    : Number.isInteger(this.requestedActiveTab)
                        ? this.requestedActiveTab
                    : localStorage.getItem('demographicsActiveTab') != null
                        ? parseInt(localStorage.getItem('demographicsActiveTab'))
                        : 1,
            openSections: {
                customNotes: true,
                chart: true,
                graphs: true,
                notes: true
            },
            // marketingActivities: [],
            marketingCampaignsCompanies: [],
            opportunities: [],
            open: true,
            showInactive: false,
            unsavedChanges: false,
            salesCount: 0,
            opportunitiesCount: 0,
            data: null,
            contacts: [],
            addresses: [],
            companyCustodianCount: 0
        };

        // this.opportunitiesArr = [5, 6, 7, 8, 9, 10, 11, 12, 16];
        this.handleAddContactsCB = null;
        this.handleAddAddressesCB = null;
        this.itemsAbortController = null;
        this.pendingItemsRequestKey = null;
        this.contactsAbortController = null;

    };


    componentDidMount() {
        // console.log('Demographics.js/componentDidMount()');
        this.setState(
            { loading: true },
            () => {
                this.getItems();
                this.getContacts();
                this.getNotes();
                this.getNotesCategories();
                // this.getMarketingActivities();
                this.getMarketingCampaignsCompanies();
                this.getSalesOpportunities();
            }
        );
        // window.addEventListener('beforeunload', this.handleBeforeUnload);
    }

    componentDidUpdate(prevProps) {
        const didClientTokenChange = this.props.clientToken !== prevProps.clientToken;
        const didPathnameChange = this.props.location?.pathname !== prevProps.location?.pathname;
        const didRequestedDateChange = this.props.location?.state?.currentDate !== prevProps.location?.state?.currentDate;

        if (!didClientTokenChange && !didPathnameChange && !didRequestedDateChange) return;

        this.setState(
            { loading: true },
            () => {
                this.getItems();
                this.getContacts();
            }
        );
    }


    componentWillUnmount() {
        if (this.itemsAbortController) this.itemsAbortController.abort();
        if (this.contactsAbortController) this.contactsAbortController.abort();
        this.setState = (state, callback) => {
            return;
        };
        // console.log('unmount')
        // window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }

    handleBeforeUnload = (e) => {
        // alert('test')
        // if (this.state.isDirty) {
        e.preventDefault();
        e.returnValue = ''; // Standard for modern browsers
        // }
    };

    handleBackNavigation = () => {
        const navState = this.props.location?.state || {};
        const explicitBackTo = navState.backTo;

        if (explicitBackTo) {
            if (typeof explicitBackTo === 'string') {
                this.props.history.push(explicitBackTo);
                return;
            }
            this.props.history.push(explicitBackTo);
            return;
        }

        if (typeof window !== 'undefined' && window.history.length > 1) {
            this.props.history.goBack();
            return;
        }

        this.props.history.push({
            pathname: '/search',
            state: { searchState: this.state.searchState, currentDate: this.state.currentDate }
        });
    };

    handleDateInputChange = (e) => {
        // console.log('Demographics.js/handleDateInputChange()');
        e.persist();

        if (e.target.name === 'current_date') {
            this.setState(
                { loading: true, currentDate: e.target.value },
                () => {
                    this.getItems();
                }
            );

        }

    }

    getMarketingCampaignsCompanies = () => {
        // console.log('Demographics.js/getMarketingCampaignsCompanies()');
        fetch('/api/marketing2CampaignsCompanies/' + this.state.secID, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    marketingCampaignsCompanies: results.data,
                });
            });
    }

    getSalesOpportunities = () => {
        // console.log('Demographics.js/getSalesOpportunities()');
        fetch('/api/salesOpportunities/' + this.state.secID, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    opportunities: results.data
                });
            });
    }

    parseNdjsonStream = async ({ response, onRow, signal }) => {
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let leftover = "";

        while (true) {
            if (signal?.aborted) break;
            const { value, done } = await reader.read();
            if (done) break;

            const chunk = decoder.decode(value, { stream: true });
            const text = leftover + chunk;
            const lines = text.split("\n");
            leftover = lines.pop() || "";

            for (const line of lines) {
                const trimmed = line.trim();
                if (!trimmed) continue;
                try {
                    const obj = JSON.parse(trimmed);
                    if (onRow) onRow(obj);
                } catch { }
            }
        }

        const tail = leftover.trim();
        if (tail) {
            try {
                const obj = JSON.parse(tail);
                if (onRow) onRow(obj);
            } catch { }
        }
    };

    getContacts = async () => {
        if (!this.props.user || !this.props.clientToken || !this.state.secID) {
            this.setState({ contacts: [] });
            return;
        }

        if (this.contactsAbortController) {
            this.contactsAbortController.abort();
        }
        this.contactsAbortController = new AbortController();

        const headers = {
            'Accept': 'application/x-ndjson',
            'Authorization': 'Bearer ' + this.props.clientToken,
            'X-Database': this.context.company
        };

        try {
            const resp = await fetch(`/api/contacts/${this.props.user}/${this.state.secID}`, {
                method: 'GET',
                headers,
                signal: this.contactsAbortController.signal
            });

            if (!resp.ok || !resp.body) {
                this.setState({ contacts: [] });
                return;
            }

            const contacts = [];
            await this.parseNdjsonStream({
                response: resp,
                signal: this.contactsAbortController.signal,
                onRow: (row) => {
                    if (!row?.error) contacts.push(row);
                }
            });

            this.setState({ contacts });
        } catch (err) {
            if (err?.name !== 'AbortError') {
                console.error('Demographics.js/getContacts error', err);
            }
        }
    }

    getItems = () => {
        const requestKey = `${this.state.secID}|${this.state.currentDate}|${this.context.company || ''}`;
        if (this.pendingItemsRequestKey === requestKey) return;

        if (this.itemsAbortController) {
            this.itemsAbortController.abort();
        }

        this.itemsAbortController = new AbortController();
        this.pendingItemsRequestKey = requestKey;

        // console.log('Demographics.js/getItems()');
        fetch('/api/demographics/' + this.state.secID + '/' + this.state.currentDate, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            },
            signal: this.itemsAbortController.signal
        })
            .then(results => results.json())
            .then(results => {
                this.setState((prevState, props) => {
                    // if (results.data.length === 0) return this.props.history.push('/');
                    let return_value = {
                        loading: false,
                        data: results.data,
                        linkedCompanies: results.linkedCompanies
                        //'currentDate': results.currentDate,
                        //'debug_message': results.debug_message,
                    };
                    return return_value;

                });
            })
            .catch(err => {
                if (err?.name !== 'AbortError') {
                    throw err;
                }
            })
            .finally(() => {
                if (this.pendingItemsRequestKey === requestKey) {
                    this.pendingItemsRequestKey = null;
                }
            });
        return;
    }

    getMetaData = () => {
        // console.log('Demographics.js/getMetaData()');
        fetch('/api/demographicsMetaData/' + this.state.secID, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState((prevState, props) => {

                    let return_value = {
                        metadata: results.data,
                        'debug_message': results.debug_message,
                    };
                    return return_value;

                });
            });
        return;
    }

    onGetMetaData = () => {
        console.log('Demographics.js/onGetMetaData()');
        this.getMetaData();
    }

    handleAddSubmit = () => {
        console.log('Demographics.js/handleAddSubmit()');
        if (this.state.selectValue === 3) {
            this.handleAddContactsCB();
            return;
        }
        if (this.state.selectValue === 44) {
            this.handleAddAddressesCB();
            return;
        }
        const json_request = JSON.stringify({
            data: this.state.addCategoryCommentsArray,
            auth0: this.props.user
        });
        const thisObj = this;
        this.setState(
            { loading: true },
            () => { }
        );
        fetch('/api/notes/' + this.state.secID, {
            method: 'POST',
            body: json_request,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.debug_message.error === null) {
                    this.getItems();
                    thisObj.getSalesOpportunities();
                    thisObj.handleCancel()
                    this.setState({
                        unsavedChanges: false
                    })
                }
            });
    }

    handleCancel = (e) => {
        console.log('Demographics.js/handleCancel()');
        this.setState(
            {
                selectValue: 0,
                loading: false,
                addCategoryCommentsArray: [],
                editCategoryCommentsArray: [],
                otherCategories: {},
                unsavedChanges: false
            },
            () => {
                this.getNotes();
            }
        );
    }

    handleEditSubmit = (e) => {
        console.log('Demographics.js/handleEditSubmit()');
        const json_request = JSON.stringify({
            data: this.state.editCategoryCommentsArray,
            orgID: this.state.orgID,
            linkedID: e.target.value,
            auth0: this.props.user
        });
        this.setState(
            { loading: true },
            () => { }
        );
        fetch('/api/notes/' + this.state.secID, {
            method: 'PUT',
            body: json_request,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.debug_message.error === null) {
                    this.handleDelete({ target: { value: results.linkedID } }, () => {
                        this.getItems();
                        this.getSalesOpportunities();
                        this.setState(
                            {
                                loading: false,
                                editCategoryCommentsArray: [],
                                unsavedChanges: false
                            },
                            () => { }
                        );
                    });
                }
            });
    }

    handleDelete = (e, cb) => {
        console.log('Demographics.js/handleDelete()');
        fetch('/api/notes/' + this.state.secID + '/' + e.target.value, {
            method: 'DELETE',
            //body: json_request,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.debug_message.error === null) {
                    this.setState(
                        {
                            editID: 0,
                            loading: false,
                            unsavedChanges: false
                        },
                        () => {
                            this.getItems();
                            this.getNotes();
                            if (cb) cb();
                        }
                    );
                }
            });
    }

    handleEditSwap = (val) => {
        console.log('Demographics.js/handleEditSwap(val)', val);
        this.displayEditCategories(val);
        this.setState({
            otherCategories: {},
            editID: val !== this.state.editID ? val : 0,
            unsavedChanges: false
        });
    }

    getNotesCategories = () => {
        // console.log('Demographics.js/getNotesCategories()');
        fetch('/api/notesCategories/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState((prevState, props) => {

                    let data = results.data;
                    let debug_message = results.debug_message;

                    let return_value = {
                        notesCategories: {
                            loading: false,
                            data: data,
                            'debug_message': debug_message,
                        }
                    };
                    return return_value;
                });
            });
        return;
    }

    getNotes = () => {
        console.log('Demographics.js/getNotes()');
        this.onGetMetaData();
        fetch('/api/notes/' + this.state.secID, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState((prevState, props) => {

                    let return_value = {
                        notesLoading: false,
                        notes: results.data,
                    };
                    return return_value;
                });
            });
        return;
    }

    displayCategories = (e) => {
        // console.log('Demographics.js/displayCategories()', e.target);
        const categoryList = typeof (this.state.notesCategories.data.filter(
            item => parseInt(item.ID) === parseInt(e.target.value)
        )[0]) !== 'undefined' ? this.state.notesCategories.data.filter(
            item => parseInt(item.ID) === parseInt(e.target.value)
        )[0].children : [];
        categoryList.forEach((item) => { item.value = null; item.error = false; })
        const categoryValue = parseInt(e.target.value);
        this.setState((prevState, props) => {
            let return_value = {
                selectValue: categoryValue,
                addCategoryCommentsArray: categoryList
            }
            return return_value;
        });
    };

    displayEditCategories = (val) => {
        // console.log('Demographics.js/displayEditCategories(val)', val);
        const dataList = typeof (this.state.notes.filter(
            item => item.linkedID === val
        )[0]) !== 'undefined' ? this.state.notes.filter(
            item => item.linkedID === val
        )[0] : [];
        const categoryList = typeof (this.state.notesCategories.data.filter(
            item => parseInt(item.ID) === parseInt(dataList.typeID)
        )[0]) !== 'undefined' ? this.state.notesCategories.data.filter(
            item => parseInt(item.ID) === parseInt(dataList.typeID)
        )[0].children : [];
        categoryList.forEach(item => {
            const matchData = dataList.children.filter(dataItem => dataItem.typeID === item.ID);
            if (matchData.length > 0) {
                item.value = parseInt(matchData[0].listID) > 0 ? parseInt(matchData[0].listID) : matchData[0].comment;
                item.commentID = matchData[0].ID;
                item.parentID = matchData[0].parentID;
                item.error = false;
            } else {
                item.value = "";
                item.commentID = null;
                item.parentID = null;
                item.error = false;
            }
        })
        this.setState((prevState, props) => {
            let return_value = {
                editCategoryCommentsArray: categoryList
            }
            return return_value;
        });
    };

    setComment = (e, validation = null) => {
        const commentsArray = [...this.state.addCategoryCommentsArray];
        const field = commentsArray.find(item => parseInt(item.ID) === parseInt(e.target.name));

        if (!field) return;

        // Handle input types
        if (e.target.type === 'select-multiple') {
            field.value = Array.from(e.target.selectedOptions, option => option.value);
        } else if (e.target.type === 'checkbox') {
            field.value = e.target.checked;
        } else {
            field.value = e.target.value;
        }

        // Run validation if applicable
        if (validation != null) {
            const matches = String(field.value).match(new RegExp(validation));
            field.error = matches == null;
        }

        // Clear error if blank/null
        if (field.value === '' || field.value == null) {
            field.error = false;
        }

        this.setState({
            addCategoryCommentsArray: commentsArray,
            unsavedChanges: true
        });
    };

    setEditComment = (e) => {
        // console.log('Demographics.js/setEditComment()');
        const commentsArray = [...this.state.editCategoryCommentsArray];
        commentsArray.filter(
            item => parseInt(item.ID) === parseInt(e.target.name)
        )[0].value = e.target.value;
        //dataArray.filter(item => parseInt(item.ID) === parseInt(e.target.name))[0]
        this.setState((prevState, props) => {
            return ({
                editCategoryCommentsArray: commentsArray,
                unsavedChanges: true
            });
        });

    }

    changeComment = (e, validation = null) => {
        // console.log('Demographics.js/changeComment()');
        const dataArray = [...this.state.editCategoryCommentsArray]
        dataArray.filter(
            item => parseInt(item.ID) === parseInt(e.target.name)
        )[0].value = (e.target.type !== 'checkbox' ? e.target.value : e.target.checked);
        if (validation != null) {
            const matches = String(e.target.value).match(new RegExp(validation));
            dataArray.filter(
                item => parseInt(item.ID) === parseInt(e.target.name)
            )[0].error = (matches == null);
        }
        if (e.target.value === '' || e.target.value == null) {
            dataArray.filter(
                item => parseInt(item.ID) === parseInt(e.target.name)
            )[0].error = false;
        }
        this.setState((prevState, props) => {
            return ({
                editCategoryCommentsArray: dataArray,
                unsavedChanges: true
            });
        });
    }

    changeOtherCategory = (categoryId, value) => {
        // console.log('Demographics.js/changeOtherCategory(categoryId, value)', categoryId, value);
        this.setState((prevState) => {
            let other = prevState.otherCategories;
            other[categoryId] = value;
            return { otherCategories: other }
        })
    }

    addCategory = (categoryId, value, mode) => {
        // console.log('Demographics.js/addCategory(categoryId, value, mode)', categoryId, value, mode);
        fetch('/api/notesCategories/', {
            method: 'POST',
            body: JSON.stringify({
                commentTypeId: categoryId,
                description: value
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                let curCategory = (mode === 'add') ? [...this.state.addCategoryCommentsArray] : [...this.state.editCategoryCommentsArray];
                const curIndex = curCategory.findIndex(item => item.ID === categoryId);
                curCategory[curIndex].list.push({
                    ID: results.data,
                    description: value,
                    longDescription: value
                })
                curCategory[curIndex].value = results.data;
                let otherCategories = { ...this.state.otherCategories }
                delete otherCategories[categoryId];
                this.getNotesCategories();
                if (mode === 'add') {
                    this.setState({
                        addCategoryCommentsArray: curCategory,
                        otherCategories: otherCategories,
                        unsavedChanges: false
                    })
                } else {
                    this.setState({
                        editCategoryCommentsArray: curCategory,
                        otherCategories: otherCategories,
                        unsavedChanges: false
                    })
                }
            });
    }

    changeDateRange = (array) => {
        // console.log('Demographics.js/changeDateRange(array)', array);
        this.setState({
            dateRange: array,
            currentDate: (array.findIndex(i => i === this.state.currentDate) === -1) ? array[array.length - 1] : this.state.currentDate
        }, () => this.getItems())
    }

    favoriteCallback = (data) => {
        // console.log('Demographics.js/favoriteCallback(data)', data);
        this.setState({
            favorites: data
        })
    }

    onChange = (e) => {
        // console.log('Demographics.js/onChange()');
        e.persist();
        this.setState((prevState) => {
            let sel = { ...prevState, unsavedChanges: true };
            sel.data[e.target.name] = e.target.value !== '' ? e.target.value : null
            return sel;
        });
    }

    showHide(element) {
        this.setState({
            open: !this.state.open
        })
    }

    setContactsHandleAdd = (cb) => {
        // console.log('Demographics.js/setContactsHandleAdd()');
        this.handleAddContactsCB = cb;
    }

    setAddressesHandleAdd = (cb) => {
        // console.log('Demographics.js/setAddressesHandleAdd()');
        this.handleAddAddressesCB = cb;
    }

    setContacts = (arr) => {
        this.setState({ contacts: Array.isArray(arr) ? arr : [] });
    }

    setAddresses = (arr) => {
        this.setState({ addresses: Array.isArray(arr) ? arr : [] });
    }

    render() {
        if (this.state.data !== undefined && this.state.data != null /*&& this.state.data?.length !== 0*/) {

            const clientList = [
                { type: '(a) Individuals', account: 'Individual Accounts', aum: 'Individual AUM' },
                { type: '(b) High Net Worth Individuals', account: 'HNW Accounts', aum: 'HNW AUM' },
                { type: '(c) Banking or Thrift Institutions', account: 'Banking or Thrift Institutions Accounts', aum: 'Banking or Thrift Institutions AUM' },
                { type: '(d) Investment Companies', account: 'Investment Companies Accounts', aum: 'Investment Companies AUM' },
                { type: '(e) Business Development Companies', account: 'Business Development Companies Accounts', aum: 'Business Development Companies AUM' },
                { type: '(f) Pooled Investment Vehicles', account: 'Pooled Investment Vehicles Accounts', aum: 'Pooled Investment Vehicles AUM' },
                { type: '(g) Pension and Profit Sharing Plans', account: 'Pension Accounts', aum: 'Pension AUM' },
                { type: '(h) Charitable Organizations', account: 'Charitable Organizations Accounts', aum: 'Charitable Organizations AUM' },
                { type: '(i) State/Municipal Government Entities', account: 'Government Entities Accounts', aum: 'Government Entities AUM' },
                { type: '(j) Other Investment Advisers', account: 'Other Investment Advisors Accounts', aum: 'Other Investment Advisors AUM' },
                { type: '(k) Insurance Companies', account: 'Insurance Companies Accounts', aum: 'Insurance Companies AUM' },
                { type: '(l) Sovereign Wealth Funds / Foreign Insitutions', account: 'Sovereign Wealth Funds and Foreign Official Institutions Accounts', aum: 'Sovereign Wealth Funds and Foreign Official Institutions AUM' },
                { type: '(m) Other Businesses Not Listed Above', account: 'Corporations Not Listed Accounts', aum: 'Corporations Not Listed AUM' },
                { type: '(n) Family Foundations', account: 'Family Foundations Accounts', aum: 'Family Foundations AUM' }
            ];
            const clientListFiltered = clientList.filter(c => this.state.data[c.aum] > 0);

            const totalList = [
                { type: 'Discretionary', account: 'Discretionary Accounts', aum: 'Discretionary AUM' },
                { type: 'Non-Discretionary', account: 'Non-Discretionary Accounts', aum: 'Non-Discretionary AUM' },
                { type: 'Total', account: 'Total Accounts', aum: 'Total AUM' }
            ];
            const totalListFiltered = totalList.filter(c => this.state.data[c.aum] > 0);

            var clientAUMTotal = 0;
            var clientAccountTotal = 0;
            clientListFiltered.forEach(i => {
                clientAUMTotal += parseFloat(this.state.data[i.aum]);
                clientAccountTotal += parseFloat(this.state.data[i.account]);
            });

            const notesContacts = [...this.state.notes].filter(row => row.type === 'Contact' || row.type === 'Company Info');
            // const notesAddresses = [...this.state.notes].filter(row => row.type === 'Address');
            const notesDemographics = [...this.state.notes].filter(row => row.type === 'System Demographics');
            const notesOther = [...this.state.notes].filter(row => row.type !== 'Contact' && row.type !== 'Address' && row.type !== 'System Demographics' && row.type !== 'Custodians');
            const notesSectionCount = this.state.notes.filter(row => row.type !== 'Contact' && row.type !== 'Address' && row.type !== 'Custodians').length;
            const tabOneCount = this.state.contacts.length + this.state.addresses.length + notesSectionCount + this.state.companyCustodianCount;

            const favorites = this.props.getFavorites();
            const isFavorite = ("sec" in favorites && favorites.sec.findIndex(favorite => favorite.Favorite === this.state.secID) > -1);
            const notesCategoriesData = this.state.notesCategories?.data || [];
            const contactNotesCategories = notesCategoriesData.find(item => item.type === 'Contact')?.children || [];
            const addressNotesCategories = notesCategoriesData.find(item => item.type === 'Address')?.children || [];

            return (
                <Container fluid={true}>
                    <Prompt
                        when={this.state.unsavedChanges}
                        message="You have unsaved changes, are you sure you want to leave?"
                    />
                    {/* <PermissionWrapper {...this.props} allowedPermission="Show Secondary Ribbon" hidden={true}> */}
                    <Row className='align-items-start'>
                        <Col md={3} className='text-left companyDetails pl-5 py-3'>
                            {this.state.data['Main Office Street Address 1'] != null ? <>{this.state.data['Main Office Street Address 1']}<br /></> : <></>}
                            {this.state.data['Main Office Street Address 2'] != null ? <>{this.state.data['Main Office Street Address 2']}<br /></> : <></>}
                            {(this.state.data['Main Office City'] != null && this.state.data['Main Office State'] != null && this.state.data['Main Office Postal Code'] != null) ?
                                <>{this.state.data['Main Office City']}, {this.state.data['Main Office State']} {this.state.data['Main Office Postal Code']}<br /></> : <></>}
                            {this.state.data['Main Office Telephone Number']}<br />
                        </Col>
                        <Col md={6} className='text-center'>
                            {this.state.data?.['DBA Business Name'] ? <><h1><span style={{ fontSize: '45%', fontWeight: 'normal' }}>DBA</span> {this.state.data['DBA Business Name']}</h1><h6>({this.state.data['Primary Business Name']})</h6></>
                                : <h1>{this.state.data['Primary Business Name']}</h1>}
                        </Col>
                        <Col md={3} className='text-right companyDetails pr-5'>
                            <Row>
                                <Col xs="12" className="text-right" >
                                    {isFavorite ?
                                        <FontAwesomeIcon icon={faStar} className="favoriteIcon" onClick={() => this.props.removeFavorite('sec', this.state.secID, this.favoriteCallback)} />
                                        : <FontAwesomeIcon icon={faStarOutline} className="favoriteIconDisabled" onClick={() => this.props.addFavorite('sec', this.state.secID, this.favoriteCallback)} />
                                    }
                                    {/* </Col>
                                    <Col xs="10"> */}
                                    <Button
                                        className="ml-3 mb-2"
                                        color="primary"
                                        onClick={this.handleBackNavigation}
                                    >
                                        Back
                                    </Button>
                                </Col>
                            </Row>

                            {this.state.data['Website Address'] != null ? <><a href={this.state.data['Website Address']} target="_blank" rel="noopener noreferrer">{this.state.data['Website Address']}</a><br /></> : ''}
                            {typeof (this.state.metadata) !== 'undefined' ? this.state.metadata.filter(item => item.Type === 'Website').map(item => (
                                <Row key={item.Comment}><Col xs={12}><img className="cssi-icon" src="/logo192.png" alt="CSSI tag" /><a key={item.Comment} href={item.Comment} target="_blank" rel="noopener noreferrer">{item.Comment}</a><br /></Col></Row>
                            )) : <></>}
                            {typeof (this.state.metadata) !== 'undefined' ? this.state.metadata.filter(item => item.Type === 'CSSI Customer Number').map(item => (
                                <Row key={item.Comment}><Col xs={12}>CSSI Customer Number: {item.Comment}<br /></Col></Row>
                            )) : <></>}
                            {typeof (this.state.metadata) !== 'undefined' ? this.state.metadata.filter(item => item.Type === 'LinkedIn URL').map(item => (
                                <Row key={item.Comment}><Col xs={12}><img className="cssi-icon" src="/linkedIn.png" alt="LinkedIn URL" /><a key={item.Comment} href={item.Comment} target="_blank" rel="noopener noreferrer">LinkedIn Page</a><br /></Col></Row>
                            )) : <></>}
                            <Row>
                                <Col xs="12">
                                    {this.state.data['Organization CRD#'] != null ? <>Organization CRD#: {this.state.data['Organization CRD#']}<br /></> : ''}
                                    {this.state.data['SEC#'] != null ? <>SEC#: {this.state.data['SEC#']}<br /></> : ''}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    {/* </PermissionWrapper> */}
                    <Row className='pt-4 gradientNav'>
                        <Col>
                            <Nav tabs className="pb-0 px-2">
                                <NavItem >
                                    <NavLink
                                        className={classnames({ active: this.state.activeTab === 1 })}
                                        onClick={() => { this.setState({ activeTab: 1 }); localStorage.setItem('demographicsActiveTab', 1); }}>
                                        Contacts, Addresses, Demographics & Notes {tabOneCount > 0 && '(' + tabOneCount + ')'}
                                    </NavLink>
                                </NavItem>
                                <NavItem >
                                    <NavLink
                                        className={classnames({ active: this.state.activeTab === 2 })}
                                        onClick={() => { this.setState({ activeTab: 2 }); localStorage.setItem('demographicsActiveTab', 2); }}>
                                        {this.state.dateRange.findIndex(item => item === '000000') === -1 /*&& this.state.dateRange.length > 0*/ ? 'Charts & Graphs' : 'Company Info'}
                                    </NavLink>
                                </NavItem>
                                <NavItem >
                                    <NavLink
                                        className={classnames({ active: this.state.activeTab === 3 })}
                                        onClick={() => { this.setState({ activeTab: 3 }); localStorage.setItem('demographicsActiveTab', 3); }}>
                                        Opportunities {this.state.opportunitiesCount > 0 && '(' + this.state.opportunitiesCount + ')'}
                                    </NavLink>
                                </NavItem>
                                <NavItem >
                                    <NavLink
                                        className={classnames({ active: this.state.activeTab === 4 })}
                                        onClick={() => { this.setState({ activeTab: 4 }); localStorage.setItem('demographicsActiveTab', 4); }}>
                                        Sales {this.state.salesCount > 0 && '(' + this.state.salesCount + ')'}
                                    </NavLink>
                                </NavItem>
                                {/* <NavItem >
                  <NavLink
                    className={classnames({ active: this.state.activeTab === 5 })}
                    onClick={() => { this.setState({ activeTab: 5 }); localStorage.setItem('demographicsActiveTab', 5); }}>
                    Marketing {this.state.marketingActivities.length > 0 && '(' + this.state.marketingActivities.length + ')'}
                  </NavLink>
                </NavItem> */}
                                <NavItem >
                                    <NavLink
                                        className={classnames({ active: this.state.activeTab === 7 })}
                                        onClick={() => { this.setState({ activeTab: 7 }); localStorage.setItem('demographicsActiveTab', 7); }}>
                                        Campaigns {this.state.marketingCampaignsCompanies.length > 0 && '(' + this.state.marketingCampaignsCompanies.length + ')'}
                                    </NavLink>
                                </NavItem>
                                {Object.keys(this.state.linkedCompanies).length > 0 && <NavItem >
                                    <NavLink
                                        className={classnames({ active: this.state.activeTab === 6 })}
                                        onClick={() => { this.setState({ activeTab: 6 }); localStorage.setItem('demographicsActiveTab', 6); }}>
                                        Child / Master Companies
                                    </NavLink>
                                </NavItem>}
                            </Nav>
                        </Col>
                    </Row>

                    <Row>
                        <Col>

                            <TabContent activeTab={this.state.activeTab}>
                                <TabPane tabId={1} className="p-2 mt-2">
                                    <Row>
                                        <Col md={12}>
                                            <NotesForm
                                                clientToken={this.props.clientToken}
                                                editID={this.state.editID}
                                                notes={notesContacts.concat(notesDemographics)}
                                                notesCategories={this.state.notesCategories}
                                                justNotes={false}
                                                justAdd={true}
                                                addCategoryCommentsArray={this.state.addCategoryCommentsArray}
                                                editCategoryCommentsArray={this.state.editCategoryCommentsArray}
                                                selectValue={this.state.selectValue}
                                                otherCategories={this.state.otherCategories}
                                                onGetMetaData={this.onGetMetaData}
                                                handleCancel={this.handleCancel}
                                                handleAddSubmit={this.handleAddSubmit}
                                                handleEditSubmit={this.handleEditSubmit}
                                                handleDelete={this.handleDelete}
                                                handleEditSwap={this.handleEditSwap}
                                                displayCategories={this.displayCategories}
                                                displayEditCategories={this.displayEditCategories}
                                                setComment={this.setComment}
                                                setEditComment={this.setEditComment}
                                                changeComment={this.changeComment}
                                                changeOtherCategory={this.changeOtherCategory}
                                                addCategory={this.addCategory}
                                                userPermissions={this.props.userPermissions}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            {notesDemographics.length > 0 && <CollapseCard title="Demographics" open={true}>
                                                <NotesForm
                                                    clientToken={this.props.clientToken}
                                                    editID={this.state.editID}
                                                    notes={notesDemographics}
                                                    notesCategories={this.state.notesCategories}
                                                    justNotes={false}
                                                    addCategoryCommentsArray={this.state.addCategoryCommentsArray}
                                                    editCategoryCommentsArray={this.state.editCategoryCommentsArray}
                                                    selectValue={this.state.selectValue}
                                                    otherCategories={this.state.otherCategories}
                                                    onGetMetaData={this.onGetMetaData}
                                                    handleCancel={this.handleCancel}
                                                    handleAddSubmit={this.handleAddSubmit}
                                                    handleEditSubmit={this.handleEditSubmit}
                                                    handleDelete={this.handleDelete}
                                                    handleEditSwap={this.handleEditSwap}
                                                    displayCategories={this.displayCategories}
                                                    displayEditCategories={this.displayEditCategories}
                                                    setComment={this.setComment}
                                                    setEditComment={this.setEditComment}
                                                    changeComment={this.changeComment}
                                                    changeOtherCategory={this.changeOtherCategory}
                                                    addCategory={this.addCategory}
                                                    userPermissions={this.props.userPermissions}
                                                />
                                            </CollapseCard>}
                                            <Contacts
                                                {...this.props}
                                                setContacts={this.setContacts}
                                                setContactsHandleAdd={this.setContactsHandleAdd}
                                                handleCancel={this.handleCancel}
                                                addCategoryCommentsArray={this.state.addCategoryCommentsArray}
                                                notesCategories={contactNotesCategories}
                                                useProvidedNotesCategories={true}
                                                secID={this.state.secID}
                                                setUnsavedChanges={(bool, cb) => this.setState({ unsavedChanges: bool }, cb)}
                                            />
                                            <Addresses
                                                {...this.props}
                                                setAddresses={this.setAddresses}
                                                setAddressesHandleAdd={this.setAddressesHandleAdd}
                                                handleCancel={this.handleCancel}
                                                addCategoryCommentsArray={this.state.addCategoryCommentsArray}
                                                notesCategories={addressNotesCategories}
                                                useProvidedNotesCategories={true}
                                                secID={this.state.secID}
                                                setUnsavedChanges={(bool, cb) => this.setState({ unsavedChanges: bool }, cb)}
                                            />
                                        </Col>
                                        <Col md={6}>
                                            <CollapseCard title="Custodians" open={true}>
                                                <CompanyCustodians
                                                    clientToken={this.props.clientToken}
                                                    secID={this.state.secID}
                                                    user={this.props.user}
                                                    checkPermission={this.props.checkPermission}
                                                    onChange={custodians => this.setState({ companyCustodianCount: custodians.length })}
                                                />
                                            </CollapseCard>
                                            {notesOther.length > 0 && <CollapseCard title="CSSI Notes" open={true}>
                                                <NotesForm
                                                    clientToken={this.props.clientToken}
                                                    editID={this.state.editID}
                                                    notes={notesOther}
                                                    justNotes={true}
                                                    notesCategories={this.state.notesCategories}
                                                    addCategoryCommentsArray={this.state.addCategoryCommentsArray}
                                                    editCategoryCommentsArray={this.state.editCategoryCommentsArray}
                                                    otherCategories={this.state.otherCategories}
                                                    selectValue={this.state.selectValue}
                                                    onGetMetaData={this.onGetMetaData}
                                                    handleCancel={this.handleCancel}
                                                    handleAddSubmit={this.handleAddSubmit}
                                                    handleEditSubmit={this.handleEditSubmit}
                                                    handleDelete={this.handleDelete}
                                                    handleEditSwap={this.handleEditSwap}
                                                    displayCategories={this.displayCategories}
                                                    displayEditCategories={this.displayEditCategories}
                                                    setComment={this.setComment}
                                                    setEditComment={this.setEditComment}
                                                    changeComment={this.changeComment}
                                                    changeOtherCategory={this.changeOtherCategory}
                                                    addCategory={this.addCategory}
                                                    userPermissions={this.props.userPermissions}
                                                />
                                            </CollapseCard>}
                                        </Col>
                                    </Row>
                                </TabPane>
                            </TabContent>

                            <TabContent activeTab={this.state.activeTab} >
                                <TabPane tabId={2} className="p-2">
                                    {this.state.activeTab === 2 && <>
                                    <Row>
                                        <Col md={12}>
                                            {this.state.dateRange.findIndex(item => item === '000000') === -1 /*&& this.state.dateRange.length > 0*/ ?
                                                // <CollapseCard title="Chart Data" open={true}>
                                                <>
                                                    <Row className="align-items-center my-3">
                                                        <Col md="4" className="text-right pt-3 font-weight-bold"><p>Data as of</p></Col>
                                                        <Col md="8">
                                                            <Input
                                                                type="select"
                                                                name="current_date"
                                                                onChange={e => this.handleDateInputChange(e)}
                                                                value={this.state.currentDate.substr(0, 2) + this.state.currentDate.substr(2, 2) + this.state.currentDate.substr(4, 2)}
                                                            >
                                                                {this.available_dates.filter(item => this.state.dateRange.includes(item.date_key)).map(d => (
                                                                    <option value={d.date_key} key={'current_date_' + d.date_string}>{d.date_string}</option>
                                                                ))}
                                                            </Input>
                                                        </Col>
                                                    </Row>



                                                    <Table>
                                                        <thead>
                                                            <tr>
                                                                <th className="text-left">AUM</th>
                                                                <th className="text-right">Value</th>
                                                                <th className="text-right">Accounts</th>
                                                                <th className="text-right">Avg. Size/Acct.</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                clientListFiltered.map(c => (
                                                                    <tr key={c.type}>
                                                                        <td className="text-left">{c.type}</td>
                                                                        <td className="text-right">${new Intl.NumberFormat().format(this.state.data[c.aum])}</td>
                                                                        <td className="text-right">{this.state.data[c.account] !== null ? this.state.data[c.account] : 0}</td>
                                                                        <td className="text-right">${this.state.data[c.account] > 0 ? (new Intl.NumberFormat().format(Math.round(this.state.data[c.aum] / (!isNaN(this.state.data[c.account]) ? this.state.data[c.account] : 5)))) : 0}</td>
                                                                    </tr>
                                                                ))
                                                            }
                                                            {
                                                                (clientAUMTotal < this.state.data['Total AUM'] || clientAccountTotal < this.state.data['Total Accounts']) ?
                                                                    <tr>
                                                                        <td className="text-left other">Other (Not Listed Above)</td>
                                                                        <td className="text-right other">${new Intl.NumberFormat().format(this.state.data['Total AUM'] - clientAUMTotal)}</td>
                                                                        <td className="text-right other">{(this.state.data['Total Accounts'] - clientAccountTotal)}</td>
                                                                        <td className="text-right other">{
                                                                            // (clientAccountTotal - this.state.data['5F(2)(f) Total # accts.']) > 0 ? new Intl.NumberFormat().format(Math.round((clientAUMTotal - this.state.data['5F(2)(c) AUM Total']) / (clientAccountTotal - this.state.data['5F(2)(f) Total # accts.']))) : 0
                                                                        }</td>
                                                                    </tr>
                                                                    : <></>
                                                            }
                                                            {
                                                                totalListFiltered.map(c => (
                                                                    <tr key={c.type}>
                                                                        <td className="text-left total">{c.type}</td>
                                                                        <td className="text-right total">${new Intl.NumberFormat().format(this.state.data[c.aum])}</td>
                                                                        <td className="text-right total">{this.state.data[c.account] !== null ? this.state.data[c.account] : 0}</td>
                                                                        <td className="text-right total">${this.state.data[c.account] > 0 ? new Intl.NumberFormat().format(Math.round(this.state.data[c.aum] / (!isNaN(this.state.data[c.account]) ? this.state.data[c.account] : 5))) : 0}</td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </>
                                                // </CollapseCard> 
                                                : <DemographicsEntry
                                                    clientToken={this.props.clientToken}
                                                    setUnsavedChanges={(bool, cb) => this.setState({ unsavedChanges: bool }, cb)}
                                                    {...this.state}
                                                    onChange={this.onChange}
                                                    handleChange={this.handleChange} />}
                                        </Col>
                                        <Col md={12}>
                                            {this.state.dateRange.findIndex(item => item === '000000') === -1 /*&& this.state.dateRange.length > 0*/ ?
                                                // <CollapseCard title="Graphs" open={true}>
                                                <DemographicsGraph columns={2} clientToken={this.props.clientToken} secID={this.state.secID} orgID={this.state.orgID} changeDateRange={this.changeDateRange} />
                                                // </CollapseCard>
                                                : null}
                                        </Col>
                                    </Row>
                                    </>}
                                </TabPane>
                            </TabContent>

                            <TabContent activeTab={this.state.activeTab}>
                                <TabPane tabId={3} className="p-2 mt-2">
                                    <Row>
                                        <Col md={12} className="text-left">
                                            <SalesOpportunitiesForm
                                                type="Opportunity"
                                                requestedOpportunityID={this.requestedSalesOpportunityType === 'Opportunity'
                                                    ? this.requestedSalesOpportunityID
                                                    : null}
                                                newStatusID={75}
                                                clientToken={this.props.clientToken}
                                                secID={this.state.secID}
                                                contacts={this.state.contacts}
                                                primaryBusinessName={this.state.data['Primary Business Name']}
                                                opportunities={this.state.opportunities}
                                                getSalesOpportunities={this.getSalesOpportunities}
                                                addCategoryCommentsArray={this.state.addCategoryCommentsArray}
                                                displayCategories={this.displayCategories}
                                                userPermissions={this.props.userPermissions}
                                                user={this.props.user}
                                                setUnsavedChanges={(bool, cb) => this.setState({ unsavedChanges: bool }, cb)}
                                                setTypesCount={(val) => this.setState({ opportunitiesCount: val })}
                                            />
                                        </Col>
                                    </Row>
                                </TabPane>
                            </TabContent>

                            <TabContent activeTab={this.state.activeTab}>
                                <TabPane tabId={4} className="p-2 mt-2">
                                    <Row>
                                        <Col md={12} className='text-left'>
                                            <SalesOpportunitiesForm
                                                type="Sale"
                                                requestedOpportunityID={this.requestedSalesOpportunityType === 'Sale'
                                                    ? this.requestedSalesOpportunityID
                                                    : null}
                                                newStatusID={81}
                                                clientToken={this.props.clientToken}
                                                secID={this.state.secID}
                                                contacts={this.state.contacts}
                                                primaryBusinessName={this.state.data['Primary Business Name']}
                                                opportunities={this.state.opportunities}
                                                getSalesOpportunities={this.getSalesOpportunities}
                                                addCategoryCommentsArray={this.state.addCategoryCommentsArray}
                                                displayCategories={this.displayCategories}
                                                userPermissions={this.props.userPermissions}
                                                user={this.props.user}
                                                setUnsavedChanges={(bool, cb) => this.setState({ unsavedChanges: bool }, cb)}
                                                setTypesCount={(val) => this.setState({ salesCount: val })}
                                                salesCount={this.state.salesCount}
                                            />
                                        </Col>
                                    </Row>
                                </TabPane>
                            </TabContent>

                            {/* <TabContent activeTab={this.state.activeTab}>
                <TabPane tabId={5} className="p-2 mt-2">
                  <Row>
                    <Col md={12}>
                      <Marketing2CampaignsDemographicsTable
                        clientToken={this.props.clientToken}
                        user={this.props.user}
                        userPermissions={this.props.userPermissions}
                        secID={this.state.secID}
                        marketingActivities={this.state.marketingActivities}
                        getMarketingActivities={this.getMarketingActivities}
                        contacts={this.contacts}
                      />
                    </Col>
                  </Row>
                </TabPane>
              </TabContent> */}

                            <TabContent activeTab={this.state.activeTab}>
                                <TabPane tabId={7} className="p-2 mt-2">
                                    {this.state.activeTab === 7 && <Row>
                                        <Col md={12}>
                                            <Marketing2CampaignsDemographicsTable
                                                clientToken={this.props.clientToken}
                                                user={this.props.user}
                                                userPermissions={this.props.userPermissions}
                                                secID={this.state.secID}
                                                marketingCampaignsCompanies={this.state.marketingCampaignsCompanies}
                                                getMarketingCampaignsCompanies={this.getMarketingCampaignsCompanies}
                                                contacts={this.state.contacts}
                                                setUnsavedChanges={(bool, cb) => this.setState({ unsavedChanges: bool }, cb)}
                                                checkPermission={this.props.checkPermission}
                                            />
                                        </Col>
                                    </Row>}
                                </TabPane>
                            </TabContent>

                            <TabContent activeTab={this.state.activeTab}>
                                <TabPane tabId={6} className="p-2 mt-2">
                                    {this.state.activeTab === 6 && <>
                                    <Row>
                                        <Col md={12}>
                                            {Object.keys(this.state.linkedCompanies).length > 0 && "Children" in this.state.linkedCompanies && this.state.linkedCompanies.Children.length > 0 ?
                                                <CollapseCard title="Sub-Companies" open={true}>
                                                    {this.state.linkedCompanies.Children.map((child, childIndex) => (
                                                        <Row key={childIndex} className="text-left linkedCompany py-1">
                                                            <NavLinkRouter
                                                                to={{ pathname: '/demographics/' + child['SEC#'], state: { currentDate: this.state.currentDate } }}>
                                                                {child.Name}</NavLinkRouter>
                                                        </Row>
                                                    ))}
                                                </CollapseCard>
                                                : <></>}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            {Object.keys(this.state.linkedCompanies).length > 0 && "Master" in this.state.linkedCompanies && this.state.linkedCompanies.Master.length > 0 ?
                                                <CollapseCard title="Master Companies" open={true}>
                                                    {this.state.linkedCompanies.Master.map((child, childIndex) => (
                                                        <Row key={childIndex} className="text-left linkedCompany py-2">
                                                            <NavLinkRouter
                                                                to={{ pathname: '/demographics/' + child['SEC#'], state: { currentDate: this.state.currentDate } }}>
                                                                {child.Name}</NavLinkRouter>
                                                        </Row>
                                                    ))}
                                                </CollapseCard>
                                                : <></>}
                                        </Col>
                                    </Row>
                                    </>}
                                </TabPane>
                            </TabContent>
                        </Col>
                    </Row>





                </Container>
            );
        } else {
            return (
                <Container>
                    <Row>
                        <Col md={12} className='text-center'>
                            <h1>Advisor Demographics</h1>
                            <p>Loading...</p>
                        </Col>
                    </Row>
                </Container>
            );
        }
    }
}



export default Demographics;
